'use client'
const iframeContainerId = 'dyn-turnkey-export-container-id';
const iframeElementId = 'dyn-turnkey-export-element-id';

export { iframeContainerId, iframeElementId };
